import Currency from 'components/Currency'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

const InputRow = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 1rem;
  overflow: hidden;
`

const Input = styled.input`
  width: 100%;
  font-weight: 500;
  font-size: 2.75rem;
  padding: 0;
  border: 0;
  outline: 0;
  box-sizing: border-box;
  color: ${color('white')};
  height: 2.75rem;
  background-color: transparent;

  -moz-appearance: textfield;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::placeholder {
    color: ${color('white')};
    opacity: 1;
  }
`

const CurrencyWrapper = styled.span`
  font-size: 1.5rem;
  line-height: 1.5rem;
  font-weight: 600;
  padding-left: 1rem;
  color: ${color('grey400')};
`

type Props = {
  amount: string
  currency: string
  e2e: string
  onAmountChange: (value: string) => void
}

const CurrencyAmountInput = ({ amount, currency, e2e, onAmountChange }: Props) => (
  <InputRow>
    <Input
      autoComplete='off'
      data-e2e={`${e2e}Input`}
      min='0'
      name='amount'
      onChange={(ev) => {
        onAmountChange(ev.target.value)
      }}
      placeholder='0'
      type='number'
      value={amount}
    />
    <CurrencyWrapper>
      <Currency code={currency} />
    </CurrencyWrapper>
  </InputRow>
)

export default CurrencyAmountInput
